import { auth, createUserWithEmailAndPassword, signInWithEmailAndPassword, signOut, onAuthStateChanged, sendSignInLinkToEmail, isSignInWithEmailLink, signInWithEmailLink } from '@/firebase.js';

const actionCodeSettings = {
    url: `${window.location.origin}/confirm-sign-in`,
    handleCodeInApp: true,
  };

const createUser = async (email, password) => {
    return await createUserWithEmailAndPassword(auth, email, password);
}

const signInUser = async (email, password) => {
    return await signInWithEmailAndPassword(auth, email, password)
}

const signOutUser = async () => {
    return await signOut(auth);
}

const getCurrentUser = async () => {
    return new Promise((resolve, reject) => {
      const unsubscribe = onAuthStateChanged(auth, (user) => {
          unsubscribe();
          resolve(user);
        }, reject);
    });
  };

const sendMagicLink = async (email) => {
    return await sendSignInLinkToEmail(auth, email, actionCodeSettings)
}

const confirmSignIn = async (url) => {
    if(isSignInWithEmailLink(auth, url)) {
  // Additional state parameters can also be passed via URL.
  // This can be used to continue the user's intended action before triggering
  // the sign-in operation.
  // Get the email if available. This should be available if the user completes
  // the flow on the same device where they started it.
  let email = window.localStorage.getItem('emailForSignIn');
  if (!email) {
    // User opened the link on a different device. To prevent session fixation
    // attacks, ask the user to provide the associated email again. For example:
    email = window.prompt('Please provide your email for confirmation');
  }
    return await signInWithEmailLink(auth, email, url)
  } else {
      throw new Error('Unable to confirm sign in using provided link')
    }
}

export default {
    createUser,
    signInUser,
    signOutUser,
    getCurrentUser,
    sendMagicLink,
    confirmSignIn
}